
export default function SubscriptionCard_benefit({header, icon, list, status, isActive}) {
  
  return (
    <div className="benefit" 
        data-aos="fade-right" style={{filter: !isActive ? "opacity(40%)" : "none"}}>
        <h2 className="subscriptionCard_benefit_header"><span className="icon">{icon}</span>{header}</h2>
        <ul>
            {list.map((item, inx)=>{
                return <li key={`SubscriptionCard_benefit_li_${inx}`}>{status} {item}</li>
            })}
        </ul>
    </div>
  )
}
